/**
 * Confirmation dialog for leaving a level in progress. `SHELL-017`, `SHELL-019`.
 *
 * Not `window.confirm()`. A native dialog cannot be styled to match an
 * installed PWA, and it is invisible to axe: there is no DOM inside a
 * UA-native modal for a rule to inspect, so the one existing accessibility
 * gate this project has (ADR-0004) would pass a screen it cannot see into.
 *
 * `role="alertdialog"`, focus trap, and the two-button shape all live in
 * `ConfirmDialog` now (Sprint 5c stage 1) -- this file is the leave-specific
 * copy and nothing else. `A11Y-021`/`SHELL-080` require the trap; they do
 * not require this component to own its implementation.
 */

import { ConfirmDialog } from '@shell/ConfirmDialog';

export interface LeaveConfirmDialogProps {
  onStay: () => void;
  onLeave: () => void;
}

export function LeaveConfirmDialog({ onStay, onLeave }: LeaveConfirmDialogProps) {
  return (
    <ConfirmDialog
      headingId="leave-confirm-heading"
      detailId="leave-confirm-detail"
      heading="Leave this level?"
      detail="Your progress will be saved so you can resume it later."
      cancelLabel="Stay"
      confirmLabel="Leave"
      onCancel={onStay}
      onConfirm={onLeave}
    />
  );
}
